// Generated by BUCKLESCRIPT VERSION 3.0.0, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Curry = require("bs-platform/lib/js/curry.js");
var $$String = require("bs-platform/lib/js/string.js");

function make(classNames) {
  return $$String.concat(" ", List.filter((function (className) {
                      return className !== "";
                    }))(classNames));
}

function ifBool(maybe, className) {
  if (maybe) {
    return className;
  } else {
    return "";
  }
}

function ifOpt(maybe) {
  if (maybe) {
    return maybe[0];
  } else {
    return "";
  }
}

function mapOpt(maybe, map) {
  if (maybe) {
    return Curry._1(map, maybe[0]);
  } else {
    return "";
  }
}

exports.make = make;
exports.ifBool = ifBool;
exports.ifOpt = ifOpt;
exports.mapOpt = mapOpt;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./~/re-classnames/src/ClassNames.bs.js
// module id = 553
// module chunks = 114276838955818